module.exports = __webpack_public_path__ + "img/bg.938e6888.png";